<template>
    <div class="coord-picker">
        <div style="font-size: 15px;">
            <div style="width:90%;display: inline-block">
                <span> 当前坐标: <template v-if="position != null && position.length > 0">{{position[0]}},{{position[1]}}</template> </span>
                <span style="margin-left: 20px;"> 地址: {{address}}</span>
            </div>
            <el-button style="margin: 10px;" type="primary" @click="onDefine"> 确定 </el-button>
        </div>

        <div class="map-container">
            <div class="inputBox">
                <el-autocomplete
                        class="inline-input"
                        v-model="adcode"
                        value-key="name"
                        :fetch-suggestions="remoteMethod"
                        placeholder="请输入关键字"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                >
                    <template slot="append">
                        <i class="el-icon-search" @click="search()"></i>
                    </template>
                </el-autocomplete>
            </div>
            <amap
                    ref="myMap"
                    cache-key="coord-picker-map"
                    mmap-style="amap://styles/whitesmoke"
                    async
                    :center.sync="center"
                    :zoom.sync="zoom"
                    is-hotspot
                    :enableHighAccuracy="true"
                    @click="onMapClick"
            >
                <amap-marker ref="myMarker" :position.sync="position" draggable :icon="icon"/>
            </amap>
        </div>
    </div>
</template>

<script>
    import {loadAmap, loadPlugins} from '@amap/amap-vue';

    export default {
        props:['location'],
        data() {
            return {
                address: "",
                center: null,
                zooms: [10,20],
                zoom: 10,
                position: [0,0],
                ps: null, //关键字搜索对象
                ac: null, //关键字搜索对象
                gcode: null,//逆地理位置转换
                cs: null,//定位地址
                adcode: '',
                icon: require('../../static/image/poi-marker-red.png'),
                // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
                results: [],
            };
        },
        created() {
            // eslint-disable-next-line no-async-promise-executor
            this.$ready = new Promise(async (resolve) => {
                const AMap = await loadAmap();
                await loadPlugins(['AMap.Geocoder', 'AMap.AutoComplete', 'AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.Icon']);
                this.cs = new AMap.Geolocation({
                    timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                    maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                    convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                    buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                    zoomToAccuracy: true      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                });
                var autoOptions = {
                    city: '全国'
                }
                this.ps = new AMap.PlaceSearch();
                this.ac = new AMap.AutoComplete(autoOptions);
                this.gcode = new AMap.Geocoder();


                if(this.location){
                    this.zoom = 15;
                    this.focus(this.location);
                }else{
                    this.cs.getCurrentPosition((status, result) => {
                        // 查询成功，result即为当前所在城市信息
                        if (result && result.info === 'LOCATE_SUCCESS') {
                            this.focus(result.position);
                        } else {
                            console.log('定位城市失败')
                        }
                    });
                }

                resolve();
            });
        },
        methods: {
            search(){
                if(this.results.length > 0){
                    this.handleSelect(this.results[0]);
                }
            },
            handleSelect(item) {
                this.focus(item.location);
            },
            //关键字查询
            remoteMethod(query, cb) {
                if (!query) {
                    this.results = [];
                } else {
                    this.ac.search(query, (status, result) => {
                        if (status === 'complete' && result.tips) {
                            this.results = result.tips.filter((t) => t.location != "");
                            // this.searchMethod(this.results[0]);
                            cb(this.results)
                        } else {
                            this.results = [];
                        }

                    });
                }
            },
            // searchMethod(query){
            //     this.ps.setCity(query.adcode);
            //     this.ps.search(query.name, function(status, result) {
            //         console.log(query);
            //         console.log("--------ps - search---------");
            //         console.log(result);
            //     })
            // },
            //地图点击某一点
            onMapClick(e) {
                if (e.lnglat) {
                    this.focus(e.lnglat);
                } else {
                    this.position = null;
                }
            },
            //选中某一点 根据经纬度坐标换算详细地址
            focus({lng, lat}) {
                const pos = [lng, lat];
                this.gcode.getAddress(pos, (status, result) => {
                    if (status === "complete" && result.info === "OK") {
                        if (result && result.regeocode) {
                            this.zoom = 15;
                            this.position = [...pos];
                            this.center = [...pos];
                            this.address = result.regeocode.formattedAddress;
                        }
                    }
                });
            },
            onDefine() {
                this.$emit('changeMap', JSON.parse(JSON.stringify({position: this.position, address: this.address})));
            }
        }
    };
</script>

<style lang="scss" scoped>
    .coord-picker {
        .map-container {
            width: 100%;
            height: 500px;
            position: relative;
        }

        .result-panel {
            position: absolute;
            left: 10px;
            top: 10px;
            width: 320px;
            display: flex;
            flex-direction: column;

            .search-bar {
                display: flex;
                align-items: center;

                .text {
                    text-overflow: ellipsis;
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                }
            }

            .result-list.ant-list-loading {
                min-height: 100px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        .info {
            position: absolute;
            right: 10px;
            top: 10px;
            padding-left: 24px;
        }

        .el-vue-search-box-container .search-box-wrapper {
            position: absolute;
            display: flex;
            align-items: center;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
        }

        .inputBox {
            position: absolute;
            top: 70px;
            left: 100px;
            z-index: 999;
            width: 360px;

            .inline-input {
                height: 45px;
                width: calc(100% - 45px);
            }

            .inputBtn {
                width: 45px;
                padding: 0;
                text-align: center;
                height: 40px;
            }
        }

        .inline-input {

            /*z-index: 999;*/
            /*margin-bottom: 20px;*/
            /*position: absolute;*/
            /*top: 70px;*/
            /*left: 100px;*/
        }

        /*.el-vue-search-box-container .search-box-wrapper .search-btn {*/
        /*    width: 45px;*/
        /*    height: 100%;*/
        /*    display: flex;*/
        /*    align-items: center;*/
        /*    justify-content: center;*/
        /*    background: transparent;*/
        /*    cursor: pointer;*/
        /*}*/
    }
</style>